import i18n from "../lib/i18n";
import { hasTransformationPrompt } from "./transformationPrompt";

export const CHALLENGE_TIMING = {
  BEFORE: 0,
  DURING: 1,
  AFTER: 2,
};

const subtypeValue = (value) => Number(value ?? 0);

/**
 * Returns the translated label for a challenge timing value.
 * `null` / `undefined` mean no filter ("All timings").
 * @param {number|null|undefined} timing - Stored timing id (`0`, `1`, `2`) or empty.
 * @returns {string} Localized timing label.
 */
export const getChallengeTimingLabel = (timing) => {
  if (timing == null || timing === "") {
    return i18n.t("All timings");
  }

  switch (Number(timing)) {
    case CHALLENGE_TIMING.BEFORE:
      return i18n.t("Before the game");
    case CHALLENGE_TIMING.DURING:
      return i18n.t("During the game");
    case CHALLENGE_TIMING.AFTER:
      return i18n.t("After the game");
    default:
      return i18n.t("All timings");
  }
};

/**
 * Whether a Challenge Timing filter is currently applied.
 * Timing `0` ("Before the game") is a valid filter and must not be treated as empty.
 * @param {number|string|null|undefined} timing
 * @returns {boolean}
 */
export const isTimingFilterActive = (timing) => timing != null && timing !== "";

export const getTaskTypeName = (task_type, { prompt, task_subtype } = {}) => {
  switch (Number(task_type)) {
    case 0:
      return subtypeValue(task_subtype) === 1
        ? i18n.t("AI Text Transformation")
        : i18n.t("Text");
    case 1:
      return hasTransformationPrompt(prompt)
        ? i18n.t("AI Photo Transformation")
        : i18n.t("Standard Photo");
    case 2:
      if (subtypeValue(task_subtype) === 1) {
        return i18n.t("Animated GIF");
      }
      if (subtypeValue(task_subtype) === 2) {
        return i18n.t("Audio");
      }
      return i18n.t("Standard Video");
    case 3:
      return i18n.t("Sticker + Photo");
    case 4:
      return i18n.t("QR Code");
    case 5:
      return i18n.t("Trivia");
    case 6:
      return i18n.t("Multiple Choice");
    case 7:
      return i18n.t("Augmented Reality + Photo");
    case 8:
      return i18n.t("Augmented Reality + Video");
    case 9:
      return i18n.t("Photo Inpainting");
    case 10:
      return i18n.t("Video Inpainting");
    case 11:
      return i18n.t("Split Path");
    default:
      return null;
  }
};
